import {
  ComboBox,
  DefaultButton,
  DialogType,
  IColumn,
  IComboBox,
  IComboBoxOption,
  ICommandBarItemProps,
  Icon,
  Label,
  Panel,
  PanelType,
  PrimaryButton,
  Stack,
  TextField,
  Toggle,
  TooltipHost,
} from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeadingBar } from "../../../components/Generic/HeadingBar";
import { TableBase } from "../../../components/Table/TableBase";
import { IException } from "../../../interfaces/base/IBase";
import { IGuardia, IGuardiaFilter } from "../../../interfaces/IGuadia";
import GuardiaService from "../../../services/guardiaService";
import {
  splitExceptionDetail,
  stackTokens,
  stackTokensHorizontal,
} from "../../../utils/Helper/helper";
import { IconHelper } from "../../../utils/Helper/iconHelper";
import ThemeBase from "../../../utils/Theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import { DialogBase } from "../../../components/Dialog/DialogBase";
import { ConfigHelper } from "../../../utils/Helper/configHelper";
import ListaPax from "./ListaPax";
import HeaderGeneric from "../../../components/Generic/headerPanel";
import { PanelGuardiaEliminar } from "./eliminar/PanelGuardiaEliminar";
import { MessageBarResponse } from "../../../components/MessageBar/MessageBarResponse";
import { codigosRespuesta } from "../../../interfaces/base/IResponse";
import { ComboBoxBase } from "../../../components/comboBoxComponent/ComboBoxBase";
import { UseComboTipoProgramacion } from "../../../hooks/combos/UseComboTipoProgramacion";
import { ProgressBarLoading } from "../../../components/ProgressBarLoading/ProgressBarLoading";
import { TableComponent } from "../../../components/Table/TableComponent";
import { IButtonGroup } from "../../../interfaces/base/ITable";
import { UseProgramacionGuardia } from "./UseProgramacionGuardia";
import { useMakeStyle } from "../../../functions/BaseStyle";
import { PanelGenerico } from "../../../components/Generic/PanelGenerico";

const initialProgramacionGuardia = () => {
  let t: IGuardia = {
    codigo: "",
    nombre: "",
    tipoProgramacion: "",
    tipoProgramacionId: null,
    trabajo: 0,
    descanso: 0,
    dia: false,
    noche: false,
    isPax: false,
  };

  return t;
};

const buttonStyles = {
  root: {
    background: "transparent",
    border: "none",
    minWidth: "16px",
    padding: 0,
  },
};

export const ListarProgramacionGuardia = () => {
  const navigate = useNavigate();

  const [hidden, setHidden] = useState(false);
  const [cantidadGuardias, setCantidadGuardias] = useState(0);
  const [data, setData] = useState<IGuardia[]>([]);
  const [dataEdit, setDataEdit] = useState<IGuardia>(null!);

  const [column, setColumn] = useState<IColumn[]>([]);
  const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar },] = useBoolean(false);
  const style = useMakeStyle();


  const [form, setForm] = useState<IGuardia>(initialProgramacionGuardia);
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [tipoGuardia, setTipoGuardia] = useState<string | null>("");

  let initialFilter: IGuardiaFilter = {
    skip: 0,
    take: 50,
    search: "",
    CodigoTipoProgramacion: tipoGuardia
  };


  /* Dialog */
  const [hideEliminarGuardia, { toggle: toggleEliminarGuardia }] =
    useBoolean(true);
  const [selId, setSelId] = useState<string | undefined>(undefined);

  /* Panel Form Registrar / Editar */
  const [isOpenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  /* Panel lista de personas Pax*/
  const [isOpenListaPax, { setTrue: openListaPax, setFalse: dismissListaPax }] =
    useBoolean(false);
  const [itemSelected, setItemSelected] = useState<IGuardia>();
  const { setFilter, items, loadingTabla, pagination, handleResetUpdate, onChangeSearch } = UseProgramacionGuardia()
  const [showTooltip, setShowTooltip] = React.useState(false);
  const [disableForm, setDisableForm] = React.useState(true);
  const [mensaje, setMensaje] = useState<string>("");
  const [status, setStatus] = useState<codigosRespuesta>(0);
  const {
    dataComboTipoProgramacion,
    onClickComboTipoProgramacion,
    _onkeyUpSearchTipoProgramacion,
    comboBoxRefTipoProgramacion,
  } = UseComboTipoProgramacion(isOpenPanel);
  const [loading, setLoading] = useState<boolean>(false);
  const [content, setContent] = useState<boolean>(true);
  const [buttonSalir, setButtonSalir] = useState<boolean>(false)

  const [
    isOpenPanelSearch,
    { setTrue: OpenPanelSearch, setFalse: dismissPanelSearch },
  ] = useBoolean(false);

  const clearPanelSearch = () => {
    dismissPanelSearch();
  };

  /* Hook */
  useEffect(() => {
    setTitleColumn();
    setup();
  }, []);

  useEffect(() => {
    validarForm();
  }, [form]);

  useEffect(() => {
    if (cantidadGuardias) {
      setForm({
        ...form,
        codigo: cantidadGuardias < 10 ? cantidadGuardias.toString().padStart(2, "0") : cantidadGuardias.toString()
      });

    }
  }, [cantidadGuardias]);

  const validarForm = () => {
    if (!form) {
      setDisableForm(true);
      return;
    }

    const { codigo, nombre, trabajo, dia, noche, descanso } = form;

    const isFormValid =
      codigo && nombre && trabajo > 0 && descanso > 0 && (dia || noche);

    setDisableForm(!isFormValid);
  };
  const reset = () => {
    setMensaje("");
    setForm(initialProgramacionGuardia);
    setStatus(0);
    dismissPanel();
    setup();
    setLoading(false);
    setContent(true);

  }

  /* Api */
  const dataGuardia = (filter: IGuardiaFilter) => {
    setData([]);
    GuardiaService.allGuardia(filter)
      .then((res) => {
        setData(res.data);
        setCantidadGuardias(res.data.items.length + 1);
        setHidden(true);
      })
      .catch((e: IException) => {
        alert(splitExceptionDetail(e));
        setHidden(true);
      });
  };

  const registrarGuardia = () => {
    setLoading(true);
    setContent(false);
    GuardiaService.addGuardia(form)
      .then((res) => {
        if (res.status === 200) {
          setup();
          handleResetUpdate()
          setMensaje("Se registró correctamente");
          setStatus(200);
          setLoading(false);
          setTimeout(() => {
            reset()
          }, 2000);
          setButtonSalir(true)

        }
      })
      .catch((e: IException) => {
        // alert(splitExceptionDetail(e));
        setMensaje(splitExceptionDetail(e));
        setStatus(500);
        setButtonSalir(true)
        setLoading(false);
      });
  };

  const actualizarGuardia = () => {
    setLoading(true);
    setContent(false);
    GuardiaService.editGuardia(form)
      .then((res) => {
        if (res.status === 200) {
          setup();
          handleResetUpdate();
          setMensaje("Se actualizó correctamente");
          setStatus(200);
          setLoading(false);
          setButtonSalir(true)
          setTimeout(() => {
            reset()
          }, 2000);
        }
      })
      .catch((e: IException) => {
        // alert(splitExceptionDetail(e));
        setMensaje(splitExceptionDetail(e));
        setButtonSalir(true)
        setStatus(500);
      });
  };

  const eliminarGuardia = () => {
    if (selId !== undefined) {
      GuardiaService.deleteGuardia(selId)
        .then((res) => {
          if (res.status === 200) {
            setup();
            setup();
            toggleEliminarGuardia();
            // alert("Se eliminó correctamente");
            setMensaje("Se eliminó correctamente");
            setStatus(200);
          }
        })
        .catch((e: IException) => {
          // alert(splitExceptionDetail(e));
          setMensaje(splitExceptionDetail(e));
          setStatus(500);
        });
    }
  };

  /* Function */
  const onChangeCombo = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    type?: string
  ) => {
    if (event !== undefined) {
      if (option !== undefined) {
        switch (type) {
          case "tipo":
            setForm({
              ...form,
              tipoProgramacionId: option.key.toString(),
            });
            break;
          default:
            break;
        }
      }
    }
  };

  const setup = () => {
    dataGuardia(initialFilter);
  };

  useEffect(() => {
    setFilter(initialFilter)
  }, [tipoGuardia])



  const _columns: IColumn[] = [
    {
      key: "numeracion",
      name: "N°",
      fieldName: "numeracion",
      minWidth: 30,
      maxWidth: 50,
      onRender: (item, index) => <>{(index ?? 0) + 1}</>
    },
    // {
    //   key: "codigo",
    //   name: "Código",
    //   fieldName: "codigo",
    //   minWidth: 40,
    //   maxWidth: 80,
    //   isResizable: true,
    //   isPadded: true,
    // },
    {
      key: "nombre",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "tipoProgramacion",
      name: "Tipo",
      fieldName: "tipoProgramacion",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "trabajo",
      name: "Días Trabajo",
      fieldName: "trabajo",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
    },
    {
      key: "descanso",
      name: "Días Descanso",
      fieldName: "descanso",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "dia",
      name: "Turno Día",
      fieldName: "dia",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
      onRender: (item: IGuardia) => {
        return <span>{`${item.dia ? "Si" : "No"}`}</span>;
      },
    },
    {
      key: "noche",
      name: "Turno Noche",
      fieldName: "noche",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
      onRender: (item: IGuardia) => {
        return <span>{`${item.noche ? "Si" : "No"}`}</span>;
      },
    },
    {
      key: "creacion",
      name: "Fecha Creación",
      fieldName: "creacion",
      minWidth: 120,
      maxWidth: 180,
      isResizable: true,
    },
    {
      key: "usuarioRegistra",
      name: "Usuario Registra",
      fieldName: "usuarioRegistra",
      minWidth: 120,
      maxWidth: 180,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 80,
      maxWidth: 100,
      fieldName: "opciones",
      isResizable: true,
      onRender: (item: any) => renderOpciones(item)
    },
  ]

  function renderOpciones(item: IGuardia) {
    return (
      <div style={{
        display: "flex",
        gap: "10px",
      }}>
        <TooltipHost
          content={`${item.isPax ? "Lista Staff" : "Desactivado"}`}
        >
          <Icon
            iconName="SecurityGroup"
            style={{
              cursor: "pointer",
              color: item.isPax
                ? ThemeBase.theme.palette.themePrimary
                : "#e1dfdd",
            }}
            className={ThemeBase.classes.iconFont}
            onClick={() => {
              if (item.isPax) {
                setItemSelected(item);
                openListaPax();
              }
            }}
          />
        </TooltipHost>
        <TooltipHost content={`Editar`}>
          <Icon
            iconName="Edit"
            style={{
              cursor: "pointer",
            }}
            className={ThemeBase.classes.iconFont}
            onClick={() => {
              setDataEdit(item);
              setForm({
                ...item,
              });
              setIsAdd(false);
              setIsEdit(true);
              openPanel();
            }}
          />
        </TooltipHost>
        <TooltipHost content={`Elminar`}>
          <Icon
            iconName="Delete"
            style={{ cursor: "pointer" }}
            className={ThemeBase.classes.iconFont}
            onClick={() => {
              setDataEdit(item);
              openPanelEliminar();
            }}
          />
        </TooltipHost>
      </div>
    );
  }

  const buttonLeft: IButtonGroup[] = [
    /* {
      onClick: () => navigate(`${ConfigHelper.urlBase()}/configuraciones`),
      text: "Atrás",
    }, */
    {
      onClick: () => {
        setForm(initialProgramacionGuardia);
        setForm({
          ...form,
          codigo: cantidadGuardias < 10 ? cantidadGuardias.toString().padStart(2, "0") : cantidadGuardias.toString()
        });
        setIsAdd(true);
        setIsEdit(false);
        openPanel();
      },
      text: "Nuevo",
    },
    {
      onClick: handleResetUpdate,
      text: "Actualizar",
    },
  ];

  const buttonRight: IButtonGroup[] = [
    {
      onClick: OpenPanelSearch,
      text: "Filtrar",
    },
  ];

  const _leftBar = () => {
    const _items: ICommandBarItemProps[] = [
      {
        ...IconHelper.ICON_BACK,
        onClick: () => navigate(`${ConfigHelper.urlBase()}/configuraciones`),
      },
      {
        ...IconHelper.ICON_ADD,
        onClick: () => {
          setForm(initialProgramacionGuardia);
          setIsAdd(true);
          setIsEdit(false);
          openPanel();
        },
      },
      {
        ...IconHelper.ICON_RELOAD,
        onClick: setup,
      },
    ];
    return _items;
  };

  const setTitleColumn = () => {
    let col: IColumn[] = [
      {
        key: "column1",
        name: "Codigo",
        fieldName: "codigo",
        minWidth: 70,
        maxWidth: 80,
        isResizable: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "column2",
        name: "Nombre",
        fieldName: "nombre",
        minWidth: 90,
        maxWidth: 90,
        isResizable: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "tipoProgramacion",
        name: "Tipo",
        fieldName: "tipoProgramacion",
        minWidth: 70,
        maxWidth: 70,
        isResizable: true,
        // data: "number",
        isPadded: true,
      },
      {
        key: "column3",
        name: "Días Trabajo",
        fieldName: "trabajo",
        minWidth: 70,
        maxWidth: 80,
        isResizable: true,
        data: "number",
        isPadded: true,
      },
      {
        key: "column4",
        name: "Días Descanso",
        fieldName: "descanso",
        minWidth: 70,
        maxWidth: 80,
        isResizable: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "column5",
        name: "Turno Día",
        fieldName: "dia",
        minWidth: 80,
        maxWidth: 90,
        isResizable: true,
        data: "string",
        isPadded: true,
        onRender: (item: IGuardia) => {
          return <span>{`${item.dia ? "Si" : "No"}`}</span>;
        },
      },
      {
        key: "column6",
        name: "Turno Noche",
        fieldName: "noche",
        minWidth: 80,
        maxWidth: 90,
        isResizable: true,
        data: "string",
        isPadded: true,
        onRender: (item: IGuardia) => {
          return <span>{`${item.noche ? "Si" : "No"}`}</span>;
        },
      },
      {
        key: "column7",
        name: "Fecha Creación",
        fieldName: "creacion",
        minWidth: 90,
        maxWidth: 100,
        isResizable: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "column8",
        name: "Usuario Registra",
        fieldName: "usuarioRegistra",
        minWidth: 90,
        maxWidth: 100,
        isResizable: true,
        data: "string",
        isPadded: true,
      },
      {
        key: "column9",
        name: "Opciones",
        fieldName: "",
        minWidth: 90,
        maxWidth: 100,
        isResizable: true,
        isCollapsible: true,
        data: "number",
        onRender: (item: IGuardia) => (
          <>
            <Stack
              horizontalAlign="end"
              horizontal
              tokens={stackTokensHorizontal}
            >
              <>
                <TooltipHost
                  content={`${item.isPax ? "Lista Staff" : "Desactivado"}`}
                >
                  <Icon
                    iconName="SecurityGroup"
                    style={{
                      cursor: "pointer",
                      color: item.isPax
                        ? ThemeBase.theme.palette.themePrimary
                        : "#e1dfdd",
                    }}
                    className={ThemeBase.classes.iconFont}
                    onClick={() => {
                      if (item.isPax) {
                        setItemSelected(item);
                        openListaPax();
                      }
                    }}
                  />
                </TooltipHost>
                <TooltipHost content={"Editar"}>
                  <Icon
                    iconName="Edit"
                    style={{ cursor: "pointer" }}
                    className={ThemeBase.classes.iconFont}
                    onClick={() => {
                      setForm({
                        ...item,
                      });
                      setIsAdd(false);
                      setIsEdit(true);
                      openPanel();
                    }}
                  />
                </TooltipHost>

                <TooltipHost content={`Eliminar`}>
                  <Icon
                    iconName="Delete"
                    style={{ cursor: "pointer" }}
                    className={ThemeBase.classes.iconFont}
                    onClick={() => {
                      // setSelId(item.id?.toString());
                      // toggleEliminarGuardia();
                      setDataEdit(item);
                      openPanelEliminar();
                    }}
                  />
                </TooltipHost>
              </>
            </Stack>
          </>
        ),
      },
    ];

    setColumn(col);
  };

  /* Event */
  const _onChangeText = (
    type: string,
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    if (event !== undefined) {
      if (newValue !== undefined) {
        switch (type) {
          // case "codigo":
          //   setForm({
          //     ...form,
          //     codigo: newValue,
          //   });
          //   break;
          case "nombre":
            setForm({
              ...form,
              nombre: newValue,
            });
            break;
          case "trabajo":
            setForm({
              ...form,
              trabajo: !isNaN(parseInt(newValue)) ? parseInt(newValue) : 0,
            });
            break;
          case "descanso":
            setForm({
              ...form,
              descanso: !isNaN(parseInt(newValue)) ? parseInt(newValue) : 0,
            });
            break;
          default:
            break;
        }
      }
    }
  };

  const _onChangeToggle = (
    type: string,
    ev: React.MouseEvent<HTMLElement>,
    checked?: boolean
  ) => {
    if (checked !== undefined) {
      switch (type) {
        case "dia":
          setForm({
            ...form,
            dia: checked,
          });
          break;
        case "noche":
          setForm({
            ...form,
            noche: checked,
          });
          break;
        case "pax":
          setForm({
            ...form,
            isPax: checked,
          });
          break;
        default:
          break;
      }
    }
  };

  const onRenderHeader = React.useCallback(
    () => (
      <HeaderGeneric
        title={`${isAdd ? "Registrar Guardia" : "Actualizar Guardia"}`}
        subTitle={`${isAdd
          ? "Complete el formulario para registrar una guardia"
          : "Complete el formulario para actualizar la guardia"
          }`}
      ></HeaderGeneric>
    ),
    [dismissPanel, isAdd]
  );

  /* Footer Panel */
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <PrimaryButton
          onClick={
            isAdd ? registrarGuardia : isEdit ? actualizarGuardia : () => { }
          }
          styles={ThemeBase.panelButtonStyle}
          disabled={disableForm}
        >
          Confirmar
        </PrimaryButton>
        <DefaultButton onClick={dismissPanel}>Cancelar</DefaultButton>
      </div>
    ),
    [dismissPanel, form, disableForm]
  );
  const onRenderFooterContent2 = React.useCallback(
    () => (
      <div>
        <></>
      </div>
    ),
    [dismissPanel, form, disableForm]
  );

  const iconWithTooltip = (
    <>
      <TooltipHost
        content={
          showTooltip
            ? "Solo personal en lista podra ser incrito en las programaciones"
            : undefined
        }
        id="InfPax"
      >
        <DefaultButton
          aria-label={"more info"}
          aria-describedby={showTooltip ? "InfPax" : undefined}
          onClick={() => setShowTooltip(!showTooltip)}
          styles={buttonStyles}
          iconProps={{ iconName: "Info" }}
        />
      </TooltipHost>
    </>
  );

  const dataGuardias = [
    {
      key: "",
      text: "NINGUNO"
    },
    {
      key: "01",
      text: "MMG"
    },
    {
      key: "02",
      text: "SSEE"
    }
  ]

  const _onChangeTipoGuardia = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        setTipoGuardia(option.key.toString())
      }
    }
  };

  return (
    <div className={style.body}>
      <HeadingBar
        title="Guardias"
        subTitle="Gestión de guardias"
        searchShow={false}
      ></HeadingBar>

      {/* <TableBase
        leftBar={_leftBar()}
        column={column}
        data={data}
        isLoading={!hidden}
      ></TableBase> */}

      <PanelGenerico
        isOpen={isOpenPanelSearch}
        onDismiss={dismissPanelSearch}
        isOnRenderHeader
        disabledFooter={false}
        iconHeaderName={IconHelper.ICON_FILTERS.filterPanel}
        title="Filtro Personalizado"
        subTitle=" Elija las condiciones para filtro personalizado"
        textRegister="Buscar"
        cancelar={clearPanelSearch}
        registrar={dismissPanelSearch}
        disabledIconHeader={false}
      >
        <div
          className="ms-Grid"
          dir="ltr"
          style={{
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "5%",
          }}
        >
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
              <ComboBox
                label="Tipo de Guardia"
                allowFreeform
                autoComplete='off'
                useComboBoxAsMenuWidth
                calloutProps={{ directionalHintFixed: true }}
                options={dataGuardias}
                onChange={_onChangeTipoGuardia}
                selectedKey={tipoGuardia}
                required
              />
            </div>
          </div>
        </div>
      </PanelGenerico>

      <TableComponent
        data={items}
        leftButtons={buttonLeft}
        rightButton={buttonRight}
        column={_columns}
        paginacion={pagination}
        isLoading={loadingTabla}
        isSearch={true}
        onChangeSearch={onChangeSearch}
      />


      {/* Panel Crear / Actualizar */}
      <Panel
        isOpen={isOpenPanel}
        onDismiss={dismissPanel}
        type={PanelType.medium}
        //headerText={`${isAdd ? "Registrar Guardia" : "Actualizar Guardia"}`}
        closeButtonAriaLabel="Close"
        onRenderHeader={onRenderHeader}

        onRenderFooterContent={(!loading && mensaje == "") ? onRenderFooterContent : buttonSalir ? onRenderFooterContent2 : undefined}
        isFooterAtBottom={true}
      >
        <div style={{ paddingTop: "5%" }}>
          <div hidden={mensaje === ""}>
            <MessageBarResponse
              objetoResponse={{ codigo: status, mensaje: mensaje }}
              close={true}
            />
          </div>
          <div hidden={!loading}>
            <ProgressBarLoading></ProgressBarLoading>
          </div>
          <form>
            <Stack tokens={stackTokens}>
              <div className="ms-Grid" dir="ltr" hidden={!content}>
                <Stack tokens={stackTokens}>
                  <div className="ms-Grid-row">
                    {/* <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <TextField
                        label="Código"
                        placeholder="Código"
                        value={form ? form.codigo : ""}
                        onChange={(e, o) => _onChangeText("codigo", e, o)}
                        autoComplete="off"
                        required
                      />
                    </div> */}

                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <TextField
                        label="Nombre"
                        placeholder="Nombre"
                        value={form ? form.nombre : ""}
                        onChange={(e, o) => _onChangeText("nombre", e, o)}
                        autoComplete="off"
                        required
                      />
                    </div>

                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <ComboBoxBase
                        title="Tipo"
                        componentRef={comboBoxRefTipoProgramacion}
                        KeyUp={_onkeyUpSearchTipoProgramacion}
                        onClick={onClickComboTipoProgramacion}
                        options={dataComboTipoProgramacion}
                        required
                        onChange={(e: React.FormEvent<IComboBox>, option) => {
                          onChangeCombo(e, option, "tipo");
                        }}
                        selectedKey={form ? form.tipoProgramacionId : ""}
                      />
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <TextField
                        label="Días Trabajo"
                        placeholder="Días Trabajo"
                        value={
                          form
                            ? form.trabajo
                              ? form.trabajo.toString()
                              : ""
                            : ""
                        }
                        onChange={(e, o) => _onChangeText("trabajo", e, o)}
                        autoComplete="off"
                        required
                      />
                    </div>

                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <TextField
                        label="Días Descanso"
                        placeholder="Días Descanso"
                        value={
                          form
                            ? form.descanso
                              ? form.descanso.toString()
                              : ""
                            : ""
                        }
                        onChange={(e, o) => _onChangeText("descanso", e, o)}
                        autoComplete="off"
                        required
                      />
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <Toggle
                        label="Turno Día"
                        onText="Si"
                        offText="No"
                        onChange={(e, v) => _onChangeToggle("dia", e, v)}
                        checked={form ? form.dia : false}
                      />
                    </div>

                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <Toggle
                        label="Turno Noche"
                        onText="Si"
                        offText="No"
                        defaultChecked
                        onChange={(e, v) => _onChangeToggle("noche", e, v)}
                        checked={form ? form.noche : false}
                      // disabled
                      />
                    </div>
                  </div>

                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                      <Toggle
                        label={<div>Solo Staff {iconWithTooltip}</div>}
                        onText="Si"
                        offText="No"
                        defaultChecked
                        onChange={(e, v) => _onChangeToggle("pax", e, v)}
                        checked={form ? form.isPax : false}
                      />
                    </div>
                  </div>
                </Stack>
              </div>
            </Stack>
          </form>
        </div>
      </Panel>

      <Panel
        isOpen={isOpenListaPax}
        onDismiss={dismissListaPax}
        type={PanelType.medium}
        headerText={`Lista Pax | ${itemSelected?.nombre!}`}
        closeButtonAriaLabel="Close"
      >
        <ListaPax GuardiaId={itemSelected?.id!}></ListaPax>
      </Panel>

      <DialogBase
        isHidden={hideEliminarGuardia}
        subTitle="La guardia será eliminado permanentemente"
        tipo={DialogType.normal}
        toggleHidden={toggleEliminarGuardia}
        dependency={[]}
        confirm={eliminarGuardia}
      ></DialogBase>

      <PanelGuardiaEliminar
        isOpen={isOpenEliminar}
        onDismiss={closePanelEliminar}
        reload={handleResetUpdate}
        guardiaData={dataEdit}
      />
    </div>
  );
};
